import { render, staticRenderFns } from "./StudentLogin.html?vue&type=template&id=01c99136&scoped=true&external"
import script from "./StudentLogin.vue?vue&type=script&lang=js"
export * from "./StudentLogin.vue?vue&type=script&lang=js"
import style0 from "./StudentLogin.css?vue&type=style&index=0&id=01c99136&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c99136",
  null
  
)

export default component.exports